export default __webpack_public_path__ + "static/media/Warehouse-building.7123fcc2.svg";